import axios from 'axios';

const API_BASE_URL = 'https://apicapmanias.umpacto.com';

// Función genérica para hacer peticiones
export const apiRequest = async (endpoint, method = 'GET', data = null) => {
    try {
        // Leer el token desde localStorage
        const token = localStorage.getItem('access_token');

        const response = await axios({
            url: `${API_BASE_URL}${endpoint}`,
            method: method,
            data: data,
            headers: {
                // Agregar el token en el encabezado Authorization si está disponible
                Authorization: token ? `Bearer ${token}` : ''
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error en la solicitud:', error);
        throw error;
    }
};

